module.exports = __webpack_public_path__ + "img/64.76c16309.png";